import PropTypes from "prop-types";

const PencilIcon = ({ color = "#2B383F", ...props }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="25"
			height="24"
			viewBox="0 0 25 24"
			fill="none"
			{...props}
		>
			<path
				d="M18.9115 3.511C18.2302 2.82967 17.1255 2.82967 16.4442 3.511L14.2578 5.69735L18.3025 9.74201L20.4888 7.55566C21.1702 6.87433 21.1701 5.76966 20.4888 5.08833L18.9115 3.511Z"
				fill={color || "currentColor"}
			/>
			<path
				d="M17.242 10.8025L13.1973 6.75781L5.10398 14.8512C4.75291 15.2022 4.50385 15.6421 4.38344 16.1238L3.52241 19.5679C3.45851 19.8235 3.5334 20.0938 3.71969 20.2801C3.90597 20.4664 4.17634 20.5413 4.43192 20.4774L7.87602 19.6164C8.35769 19.496 8.79757 19.2469 9.14864 18.8958L17.242 10.8025Z"
				fill={color || "currentColor"}
			/>
			<path
				d="M11.75 19H17.75C18.0262 19 18.25 19.2238 18.25 19.5C18.25 19.7762 18.0262 20 17.75 20H11.75C11.4738 20 11.25 19.7762 11.25 19.5C11.25 19.2238 11.4738 19 11.75 19Z"
				fill={color || "currentColor"}
				stroke={color || "currentColor"}
			/>
		</svg>
	);
};

PencilIcon.propTypes = {
	color: PropTypes.string,
};

export default PencilIcon;
